export enum TemplateType {
    Themed = 1,
    ComponentBased = 2,
    Layout = 0,
    FinishedTemplate = 3
}
